import React, { Suspense } from "react";
import Private from "components/Private";
import ErrorBoundary from "components/ErrorBoundary";
import ErrorFallback from "components/fallbacks/ErrorFallback";
import { Spinner } from "components/Spinner/Spinner";
import { Footer } from "components/PageComponents/Footer";
import { NavBar } from "components/PageComponents/navBar/NavBar";
import { useDispatch } from "react-redux";
import { changeNavType } from "reducers/navbar";
import { changeFooterType, FooterType } from "reducers/footer";
import { WindowLocation } from "@reach/router";
import Navigation from "components/navigation/components/Navigation";

const Page: React.FC<{
  isPublic?: boolean;
  navType: string;
  navData: { title: string } | null;
  footerType: FooterType | null;
  location: WindowLocation;
}> = ({ children, isPublic, navType, navData, footerType, location }) => {
  const dispatch = useDispatch();
  const [mobileNavOpen, setMobileNavOpen] = React.useState(false);

  React.useEffect(() => {
    dispatch(changeNavType({ navType, data: navData }));
    dispatch(changeFooterType({ footerType, data: null }));
  }, []);

  if (isPublic)
    return (
      <ErrorBoundary fallback={<ErrorFallback />}>
        <>
          <NavBar
            isThemed={false}
            mobileNavOpen={mobileNavOpen}
            setMobileNavOpen={setMobileNavOpen}
          />
          <Suspense fallback={<Spinner />}>{children}</Suspense>
          <Footer isThemed={false}></Footer>
        </>
      </ErrorBoundary>
    );

  return (
    <Private>
      <ErrorBoundary fallback={<ErrorFallback />}>
        <>
          <div
            className={`Overlay ${mobileNavOpen ? "MobileNavOpen" : ""} `}
          ></div>
          <Suspense fallback={<Spinner />}>
            <NavBar
              isThemed={false}
              mobileNavOpen={mobileNavOpen}
              setMobileNavOpen={setMobileNavOpen}
            />

            <div className={`PageInner ${mobileNavOpen ? "Open" : ""}`}>
              <Navigation
                location={location}
                closeMobileNav={() => setMobileNavOpen(false)}
                mobileNavOpen={mobileNavOpen}
              />
              {children}
            </div>
          </Suspense>
          <Footer isThemed={false}></Footer>
        </>
      </ErrorBoundary>
    </Private>
  );
};

export default Page;
